// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__hO-Q9","active":"Pagination_active__kUKPh"};